import { useState, useEffect, memo } from 'react';

// ── Badge Status Map ──
export const SB_MAP = {active:"b-green",new:"b-blue",contacted:"b-amber",qualified:"b-purple",closed:"b-green",paused:"b-amber",draft:"b-gray",pending:"b-amber",approved:"b-green",rejected:"b-red",connected:"b-green",disconnected:"b-gray",paid:"b-green"};

/* ── HELPERS ── */
export const Bdg = ({s}) => <span className={`badge ${SB_MAP[s]||"b-gray"}`}>{s}</span>;
export const Av = ({name,grad,size=32,online=false}) => (
  <div className={`av${online?" av-on":""}`} style={{width:size,height:size,background:grad,fontSize:size*.33,boxShadow:"0 2px 9px rgba(0,0,0,.12)"}}>{name}</div>
);
export const Counter = ({to,suffix=""}) => {
  const [v,setV] = useState(0);
  useEffect(()=>{let s=null;const d=1300;const step=ts=>{if(!s)s=ts;const p=Math.min((ts-s)/d,1);setV(Math.round((1-Math.pow(1-p,4))*to));if(p<1)requestAnimationFrame(step);};const id=requestAnimationFrame(step);return()=>cancelAnimationFrame(id);},[to]);
  return <>{v.toLocaleString()}{suffix}</>;
};
export const Toggle = ({on=true,onChange}) => (
  <div className="toggle" style={{background:on?"var(--blue)":"rgba(0,0,0,.15)"}} onClick={()=>onChange?.(!on)}>
    <div className="toggle-thumb" style={{left:on?"21px":"3px"}}/>
  </div>
);
export const Sparkline = memo(({data, color="#0891b2", height=36, width=90}) => {
  const [anim, setAnim] = useState(false);
  useEffect(()=>{ const t = setTimeout(()=>setAnim(true), 300); return()=>clearTimeout(t); },[]);
  if(!data||data.length<2) return null;
  const max = Math.max(...data); const min = Math.min(...data);
  const pts = data.map((v,i)=>{
    const x = (i/(data.length-1))*(width-4)+2;
    const y = height - 4 - ((v-min)/(max-min||1))*(height-8);
    return `${x},${y}`;
  }).join(" ");
  const area = `M2,${height} L${pts.split(" ").map(p=>p).join(" L")} L${width-2},${height} Z`;
  const uid = `sp${color.replace("#","")}${width}`;
  return (
    <svg width={width} height={height} style={{overflow:"visible"}}>
      <defs>
        <linearGradient id={`sg${uid}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.22"/>
          <stop offset="100%" stopColor={color} stopOpacity="0"/>
        </linearGradient>
        <clipPath id={`sc${uid}`}>
          <rect x="0" y="0" width={anim?width:0} height={height} style={{transition:"width 1.2s cubic-bezier(.16,1,.3,1)"}}/>
        </clipPath>
      </defs>
      <path d={area} fill={`url(#sg${uid})`} clipPath={`url(#sc${uid})`}/>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        clipPath={`url(#sc${uid})`}/>
      <circle cx={pts.split(" ").slice(-1)[0].split(",")[0]}
              cy={pts.split(" ").slice(-1)[0].split(",")[1]}
              r="3" fill={color} opacity={anim?1:0} style={{transition:"opacity .3s .9s"}}/>
    </svg>
  );
});
export const BarChart = memo(({data})=>{
  const [a,setA]=useState(false);
  useEffect(()=>{const t=setTimeout(()=>setA(true),100);return()=>clearTimeout(t);},[]);
  if (!data || data.length === 0) {
    return <div style={{padding:"24px 0",textAlign:"center",fontSize:12,color:"var(--t3)"}}>No data yet</div>;
  }
  const src = data.map(d=>({d:d.day?.slice(0,3)||d.d||'',l:d.leads||d.l||0,c:d.conversions||d.c||0}));
  const max = Math.max(...src.map(s=>Math.max(s.l,s.c)),1);
  return (<div className="bars">{src.map(({d,l,c})=>(<div key={d} className="bw"><div style={{display:"flex",gap:2,alignItems:"flex-end",width:"100%"}}><div className="b b-bl" style={{flex:1,height:a?`${(l/max)*82}px`:"4px"}}/><div className="b b-gn" style={{flex:1,height:a?`${(c/max)*82}px`:"4px"}}/></div><div className="bl">{d}</div></div>))}</div>);
});
export const Ring = memo(({pct=74,size=104})=>{
  const [a,setA]=useState(false);const circ=2*Math.PI*44;
  useEffect(()=>{const t=setTimeout(()=>setA(true),350);return()=>clearTimeout(t);},[]);
  return (<div className="rw"><svg width={size} height={size} viewBox="0 0 110 110"><circle cx="55" cy="55" r="44" fill="none" stroke="rgba(0,0,0,.07)" strokeWidth="7"/><circle cx="55" cy="55" r="44" fill="none" stroke="url(#rg)" strokeWidth="7" strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={a?circ*(1-pct/100):circ} style={{transition:"stroke-dashoffset 1.6s cubic-bezier(.16,1,.3,1)"}}/><defs><linearGradient id="rg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#64748b"/><stop offset="100%" stopColor="#18181b"/></linearGradient></defs></svg><div className="rl"><div className="rv">{pct}%</div><div className="rs2">Goal</div></div></div>);
});
export const AiScoreRing = memo(({score,size=34})=>{
  const circ=2*Math.PI*14;const col=score>=85?"#059669":score>=65?"#d97706":"#dc2626";
  return (<div style={{position:"relative",width:size,height:size,flexShrink:0}}><svg width={size} height={size} viewBox="0 0 34 34" style={{transform:"rotate(-90deg)"}}><circle cx="17" cy="17" r="14" fill="none" stroke="rgba(0,0,0,.07)" strokeWidth="3"/><circle cx="17" cy="17" r="14" fill="none" stroke={col} strokeWidth="3" strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={circ*(1-score/100)}/></svg><div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:730,color:col}}>{score}</div></div>);
});
export const Toast = ({msg,type="success",onDone})=>{
  useEffect(()=>{const t=setTimeout(onDone,2600);return()=>clearTimeout(t);},[]);
  const ico=type==="ai"?"✦":type==="error"?"✕":"✓";
  return (<div className={`toast toast-${type}`}><div className="toast-ico">{ico}</div>{msg}</div>);
};
export const PH = ({eyebrow,title,sub,live=false,action=null})=>(
  <div className="ph" style={{display:"flex",alignItems:"flex-end",justifyContent:"space-between"}}>
    <div><div className="ph-ew">{eyebrow}</div><h1 className="ph-t">{title}</h1>{sub&&<p className="ph-s">{live&&<span className="live"><span className="ldot"/>&nbsp;Live</span>}{sub}</p>}</div>
    {action}
  </div>
);

/* ═══════════════════════════════════════════
   MODAL: NEW SUBTEAM
═══════════════════════════════════════════ */
export const TEAM_COLORS = ["#64748b","#18181b","#059669","#d97706","#dc2626","#0891b2","#db2777","#7c3aed","#ea580c","#0d9488"];
